module.exports = __webpack_public_path__ + "assets/icons/ic_file_export.svg";